import React, { Component } from 'react';
import Modal from 'react-modal';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {showLoginModal} from '../../../actions/index';
import AuthorFollowersFeedContainer from '../../../containers/Author/FollowersFeed';
import {Icon} from '../../Common/Icon';
import cx from '../../../styles';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if(typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

const customStyles = {
        content: {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            marginRight           : '-50%',
            transform             : 'translate(-50%, -50%)',
            width                 : '300px'
        }
    };

class AuthorSocialCircleModal extends Component {

    constructor(props) {
        super(props);
        this.state = {isOpen: false};
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.isModalOpen) {
            if(!nextProps.userReducer.id) {
                nextProps.showLoginModal();
                this.onModalClose();
            } else {
                this.openModal();
            }
        }
    }

    openModal = () => {
        this.setState({isOpen: true});
    }

    closeModal = () => {
        this.setState({isOpen: false});
    }

    onModalOpen = () => {
        this.setState({isOpen: true});
    }

    onModalClose = () => {
        this.setState({isOpen: false});
        if(this.props.onModalClose) this.props.onModalClose();
    }

    render() {

        //for followers heading
        const { t } = this.props;
        const followersHeading = this.props.mode == "followers" ? t('profile_follower') : t('profile_following');
        //end

        return (
            <React.Fragment>
                <Modal isOpen={this.state.isOpen}
                    onAfterOpen={this.onModalOpen}
                    onRequestClose={this.onModalClose}
                    overlayClassName="myOverlayClass"
                    style={customStyles} >

                    <div className={cx("social-circle-modal")}>
                        <span className={cx("close-modal")} onClick={this.onModalClose} >
                            <Icon className={cx("not-mobile")} name="close-regular-black-sm" />
                            <Icon className={cx("only-mobile")}  name="cross-regular-dark-smd" />
                        </span>
                        <h4 className={cx("followers-heading")}>{followersHeading}</h4>
                        <AuthorFollowersFeedContainer mode={this.props.mode}
                            userId={this.props.userId}
                            afterUserClick={this.onModalClose} />
                    </div>

                </Modal>
            </React.Fragment>
        );
    }
}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
}

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showLoginModal        
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthorSocialCircleModal);
